// extracted by mini-css-extract-plugin
export default {"img":"viewFileImage_img__YaQiU"};